import { ChangeDetectionStrategy, Component, DestroyRef, inject, input } from '@angular/core';
import type { RowObject } from '@highcharts/dashboards/es-modules/Data/DataTable.js';
import type { DashboardDataState } from '../state/dashboard-data-state';
import type { DashboardFilterHandle } from '../filters/dashboard-filter.types';
import type { DashboardQueryKey } from '@h20/contracts/types/api/dashboard/DashboardQueryCatalog';
import type { DashboardQueryMeta } from '@h20/contracts/types/api/dashboard/DashboardData';

/**
 * Base class for a component mounted in a Dashboards cell.
 *
 * Change-detection strategy is not inherited, so every subclass declares its own `OnPush`.
 */
@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class DashboardWidget<TRow = RowObject, TConfig = unknown> {
    readonly rows = input<readonly TRow[]>([]);
    readonly queryKey = input<DashboardQueryKey | undefined>(undefined);
    readonly config = input<TConfig | undefined>(undefined);
    readonly state = input<DashboardDataState>({ status: 'ready' });
    readonly filters = input<DashboardFilterHandle | undefined>(undefined);
    readonly meta = input<DashboardQueryMeta | undefined>(undefined);
    protected readonly destroyRef = inject(DestroyRef);
}
